// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-container {
  width: 400px;
  height: 600px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.widget-container.loading,
.widget-container.error {
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.loading-spinner {
  font-size: 16px;
  color: #666;
}

.error-message {
  color: #d32f2f;
  margin-bottom: 16px;
  text-align: center;
}

.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.widget-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.settings-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.settings-button:hover {
  background-color: #f0f0f0;
}

.widget-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.widget-avatar-section {
  height: 200px;
  padding: 8px;
}

.widget-chat-section {
  flex: 1;
  min-height: 0;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .widget-container {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;EACzC;kFACgF;AAClF;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":[".widget-container {\n  width: 400px;\n  height: 600px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.widget-container.loading,\n.widget-container.error {\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.loading-spinner {\n  font-size: 16px;\n  color: #666;\n}\n\n.error-message {\n  color: #d32f2f;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.widget-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.widget-header h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.settings-button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.settings-button:hover {\n  background-color: #f0f0f0;\n}\n\n.widget-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.widget-avatar-section {\n  height: 200px;\n  padding: 8px;\n}\n\n.widget-chat-section {\n  flex: 1;\n  min-height: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .widget-container {\n    width: 100%;\n    height: 100vh;\n    border-radius: 0;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
